import { getDefaultMargin, getDefaultMarginOverlay, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const FormDesignSettings = {
  'form-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  'form-design-h-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  'form-design-comp-title-align': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },

  'form-design-padding': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
  },
  'form-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },
  'form-design-field-margin': {
    phone: getDefaultMargin([0, 10, 20, 10]),
    'phone-landscape': getDefaultMargin([0, 10, 20, 10]),
    tablet: getDefaultMargin([0, 10, 20, 10]),
    'tablet-landscape': getDefaultMargin([0, 10, 20, 10]),
    desktop: getDefaultMargin([0, 10, 20, 10]),
    tv: getDefaultMargin([0, 10, 20, 10]),
  },
  'form-design-comp-title-margin': {
    phone: getDefaultMargin([10, 0]),
    'phone-landscape': getDefaultMargin([10, 0]),
    tablet: getDefaultMargin([10, 0]),
    'tablet-landscape': getDefaultMargin([10, 0]),
    desktop: getDefaultMargin([10, 0]),
    tv: getDefaultMargin([10, 0]),
  },

  // Title text color (adaptive/solid/gradient)
  'form-design-title-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'form-design-title-color-solid': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'form-design-title-color-start-gradient': {
    light: 'primary-40',
    dark: 'primary-40',
  },
  'form-design-title-color-end-gradient': {
    light: 'primary-80',
    dark: 'primary-80',
  },
  'form-design-title-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },

  // Label text color (adaptive/solid/gradient)
  'form-design-label-color': {
    light: 'adaptive',
    dark: 'adaptive',
  },
  'form-design-label-color-solid': {
    light: 'primary-30',
    dark: 'primary-30',
  },
  'form-design-label-color-start-gradient': {
    light: 'primary-30',
    dark: 'primary-30',
  },
  'form-design-label-color-end-gradient': {
    light: 'primary-70',
    dark: 'primary-70',
  },
  'form-design-label-color-gradient-direction': {
    light: 'to-right',
    dark: 'to-right',
  },

  'form-design-typography': {
    // 'form-design-label-typography': {
    //   phone: getDefaultTypography('Label Medium'),
    //   'phone-landscape': getDefaultTypography('Label Medium'),
    //   tablet: getDefaultTypography('Label Medium'),
    //   'tablet-landscape': getDefaultTypography('Label Medium'),
    //   desktop: getDefaultTypography('Label Medium'),
    //   tv: getDefaultTypography('Label Medium'),
    // },
    // 'form-design-input-typography': {
    //   phone: getDefaultTypography('Body Medium'),
    //   'phone-landscape': getDefaultTypography('Body Medium'),
    //   tablet: getDefaultTypography('Body Medium'),
    //   'tablet-landscape': getDefaultTypography('Body Medium'),
    //   desktop: getDefaultTypography('Body Medium'),
    //   tv: getDefaultTypography('Body Medium'),
    // },
    // 'form-design-help-typography': {
    //   phone: getDefaultTypography('Label Small'),
    //   'phone-landscape': getDefaultTypography('Label Small'),
    //   tablet: getDefaultTypography('Label Small'),
    //   'tablet-landscape': getDefaultTypography('Label Small'),
    //   desktop: getDefaultTypography('Label Small'),
    //   tv: getDefaultTypography('Label Small'),
    // },
    'form-design-comp-title-typography': {
      phone: getDefaultTypography('headline-small'),
      'phone-landscape': getDefaultTypography('headline-small'),
      tablet: getDefaultTypography('headline-small'),
      'tablet-landscape': getDefaultTypography('headline-small'),
      desktop: getDefaultTypography('headline-small'),
      tv: getDefaultTypography('headline-small'),
    },
  },
}
